import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "./components";
import { BlogProvider, CourseProvider } from "./contexts";

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<BrowserRouter>
			<CourseProvider>
				<BlogProvider>
					<ScrollToTop />
					<App />
				</BlogProvider>
			</CourseProvider>
		</BrowserRouter>
	</React.StrictMode>
);

